

import styled from "styled-components";
import theme from "../../../UI/theme";

const TextArea = styled.textarea`
    font-size: 0.9rem;
    padding: 10px;
    border: none;
    resize: vertical;
    background-color: ${theme.colors.darkSpace80};
    outline: none;
    color: white;
    width: 100%;
    margin-top: 20px;
`
    
export default TextArea;